<template>
  <div>
    <div class="page">
      <div class="titletext">请填写稿件基本信息</div>
      <!-- <el-form style="width: 100%;display: flex;flex-direction: column;align-items: center;" :model="ruleForm"
        :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm"> -->
      <el-form style="width: 100%;display: flex;flex-direction: column;align-items: center;" :model="ruleForm"
        ref="ruleForm" label-width="0px" class="demo-ruleForm">
        <!-- 稿件标题： -->
        <el-form-item style="width: 70%;text-align: center;" prop="title">
          <div class="row">
            <div class="rowleft">
              稿件标题：
            </div>
            <div class="rowright">
              <el-input placeholder="请输入稿件标题" v-model="ruleForm.title"></el-input>
            </div>
          </div>
        </el-form-item>
        <!-- 稿件作者： -->
        <el-form-item style="width: 70%;text-align: center;" prop="author">
          <div class="row">
            <div class="rowleft">
              稿件作者：
            </div>
            <div class="rowright">
              <el-input placeholder="请输入作者名称" v-model="ruleForm.author"></el-input>
            </div>
          </div>
        </el-form-item>
        <!-- 稿件摘要： -->
        <el-form-item style="width: 70%;text-align: center;" prop="abstract">
          <div class="row1">
            <div class="rowleft1">
              稿件摘要：
            </div>
            <div class="rowright2">
              <!-- <el-input placeholder="请输入摘要内容" v-model="ruleForm.abstract"></el-input> -->
              <el-input autosize type="textarea" placeholder="请输入摘要内容" v-model="ruleForm.abstract">
              </el-input>
              <div style="width: 100%;border-bottom: 1px solid rgb(158, 156, 156);"></div>
            </div>
          </div>
        </el-form-item>

        <!-- 机密稿件： -->
        <el-form-item style="width: 70%;text-align: center;" prop="abstract">
          <div class="row">
            <div class="rowleft">
              机密稿件：
            </div>
            <div class="rowright">
              <RadioGroup style="width: 100%;text-align: left;" v-model="ruleForm.publicOrNot">
                <Radio style="margin-left: 30px;" label="1">
                  <span>否</span>
                </Radio>
                <Radio style="margin-left: 15px;" label="2">
                  <span>是</span>
                </Radio>


              </RadioGroup>
            </div>
          </div>
        </el-form-item>
        <!-- 稿件类目： -->
        <el-form-item style="width: 70%;text-align: center;" prop="manuscriptType">
          <div style="margin-top: 30px;" class="row">
            <div class="rowleft">
              稿件类目：
            </div>
            <div class="rowright" style="justify-content: flex-start;">
              <el-cascader placeholder="请选择稿件类目" clearable style="min-width: 220px; min-height: 40px;" ref="mycascader"
                :show-all-levels="false" v-model="ruleForm.manuscriptType" :options="manuscriptTypeOptions"
                :props="props" collapse-tags></el-cascader>
              <div style="flex: 1;display: flex;align-items: center;">
                <div style="flex: 1;display: flex;justify-content: flex-start;">
                  <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
                    @close="handleClose(tag)">
                    {{tag}}
                  </el-tag>
                  <el-input class="input-new-tag" style="min-width: 140px;" v-if="inputVisible" placeholder="请输入"
                    v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm">
                  </el-input>
                </div>
                <el-button style="width: 68px;" v-if="!inputVisible" class="button-new-tag" size="mini"
                  @click="showInput" round>自定义</el-button>
              </div>
              <!-- <el-input placeholder="请选择稿件类目" v-model="ruleForm.manuscriptType"></el-input> -->
            </div>
          </div>
        </el-form-item>


        <!-- 快速填充： -->
        <el-form-item style="width: 70%;text-align: center;" prop="abstract">
          <div class="row1">
            <div class="rowleft1">
              快速填充：
            </div>
            <div class="rowright3">
              <!-- <el-input placeholder="请输入摘要内容" v-model="ruleForm.abstract"></el-input> -->
              <el-input style="width: 600px" autosize type="textarea"
                :placeholder="placeholderQuickFillEmail" v-model="quickfillemail">
              </el-input>
              <el-button @click="quickfillClick" style="width: 68px;" class="button-new-tag" size="mini" round>填充
              </el-button>
              <!-- <div style="width: 100%;border-bottom: 1px solid rgb(158, 156, 156);"></div> -->
            </div>
          </div>
        </el-form-item>

        <!-- 所投编辑： -->
        <el-form-item style="width: 70%;text-align: center;" prop="abstract">
          <div style="margin-bottom: 20px;margin-top: 40px;" class="row1">
            <div class="rowleft1">
              所投编辑：
            </div>
            <div class="rowright1">
              <table id="tablelist" style="width: 100%;" cellspacing="0" cellpadding="0">
                <tr style="height: 35px;">
                  <td style="width: 10%;">序号</td>
                  <td style="width: 35%;">邮箱</td>
                  <td style="width: 35%;">备注</td>
                  <!-- <td style="width: 10%;">
                    <el-button v-if="!btnshowhide" size="mini" @click="btnshowhide=!btnshowhide" round>添加</el-button>
                    <el-button @click="emailAdd" v-else size="mini" type="primary" round>保存</el-button>
                  </td> -->
                </tr>
                <tr v-for="(item,index) in tabemailList" style="height: 35px;">
                  <td style="width: 10%;">{{index+1}}</td>
                  <td style="width: 35%;">
                    {{item.email}}
                  </td>
                  <td style="width: 35%;">
                    {{item.remarks}}
                  </td>
                  <!-- <td style="width: 10%;">
                    <Button @click="deleterow(index)" size="small" icon="md-close" type="error" shape="circle"></Button>
                  </td> -->
                </tr>
                <!-- <tr v-if="tabemailList.length!=0 || btnshowhide" style="height: 35px;">
                  <td style="width: 10%;">{{tabemailList.length+1}}</td>
                  <td style="width: 35%;">
                    <el-input @blur="emailblur" v-model="tabemail" placeholder="请输入邮箱地址"></el-input>
                  </td>
                  <td style="width: 35%;">
                    <el-input v-model="tabremarks" placeholder="请输入备注信息"></el-input>
                  </td>
                  <td style="width: 10%;border-left: none;">
                  </td>
                </tr> -->
                <tr v-if="tabemailList.length==0">
                  <td style="width: 100%;height: 200px;" colspan="4">
                    <img src="../assets/nodata1.png" alt="">
                    <div style="font-size: 13px;color: #aca8a8;">所投编辑人邮箱为空，快去添加吧！</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </el-form-item>
        <!-- 稿件协议： -->
        <el-form-item style="width: 70%;text-align: center;" prop="abstract">
          <div style="margin-bottom: 20px;" class="row">
            <div class="rowleft">
              稿件协议：
            </div>
            <div style="border: none;justify-content: flex-start;" class="rowright">
              <div @click="templateClick(index)" v-for="(item,index) in templateList" id="templateid"
                :class="{active : item.state}">{{item.name}}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="page2">
      <quill-editor ref="text" v-model="content" class="myQuillEditor" :options="editorOption" />
      <el-button :loading="submitloading" @click="submitForm()" style="width: 300px;height: 50px;margin-top: 50px;"
        type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { quillEditor } from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  export default {
    components: {
      quillEditor
    },
    data() {
      return {
        submitloading: false,
        //稿件类目数据源
        manuscriptTypeOptions: [],
        btnshowhide: false,
        content: '',//协议内容
        editorOption: {},
        props: { multiple: true, expandTrigger: 'hover' },
        dynamicTags: [],
        inputVisible: false,
        inputValue: '',
        tabemail: "",//表格邮箱地址
        tabremarks: "",//表格邮箱备注
        tabemailList: [],//邮箱列表
        templateList: [{
          id: '1',
          name: '协议模板1',
          content: '模板内容1',
          state: true,
        }, {
          id: '2',
          name: '协议模板2',
          content: '模板内容2',
          state: false,
        }, {
          id: '3',
          name: '协议模板3',
          content: '模板内容3',
          state: false,
        }],
        ruleForm: {
          title: "",//标题
          author: "",//作者
          abstract: "",//摘要
          manuscriptType: '',//稿件类目
          publicOrNot: "2"//是否公开
        },
        //快速填充邮件
        quickfillemail: '27878247@qq.com,张三;\n27878247@qq.com,张三;\n27878247@qq.com,张三;',
        placeholderQuickFillEmail: '27878247@qq.com,张三;\n27878247@qq.com,张三;\n27878247@qq.com,张三;',
        // 校验规则
        rules: {
          title: [
            { required: true, message: '请输入稿件标题', trigger: 'blur' },
          ],
          author: [
            { required: true, message: '请输入作者名称', trigger: 'blur' },
          ],
          manuscriptType: [
            { required: true, message: '请选择稿件类目', trigger: 'blur' },
          ],
        },
        //自定义节点
        dynamicTags: [],
        inputVisible: false,
        inputValue: ''
      }
    },
    watch: {
      'ruleForm.manuscriptType'(newVal, oldVal) {
        // // console.log(newVal);
        // console.log(this.ruleForm.manuscriptType);
        var num = parseInt(this.ruleForm.manuscriptType.length) + parseInt(this.dynamicTags.length);
        if (num >= 6) {
          this.$Message.error('最多只能选择5类标签！');
          this.$nextTick(() => {
            this.ruleForm.manuscriptType = oldVal;
          })
        }
      }
    },
    //初始化方法
    mounted() {
      this.getManuscriptTypeOptions();
    },
    methods: {
      //快速识别
      quickfillClick() {
        if (!this.quickfillemail) {
          this.$Message.error('识别内容不能为空！');
          this.tabemailList = [];
          return;
        }
        try {
          if (this.quickfillemail.replace(/[\r\n]/g, '').indexOf(',') != -1) {
            var data = this.quickfillemail.replace(/[\r\n]/g, '').split(";");
            this.tabemailList = [];
            for (let index = 0; index < data.length; index++) {
              if (data[index] != "") {
                var item = data[index];
                //验证,
                if (item.indexOf(',') != -1) {
                  if (item.split(",").length > 2) {
                    this.$Message.error('格式不正确！');
                    return;
                  }
                } else {
                  this.$Message.error('格式不正确！');
                  return;
                }
                //验证邮箱格式
                if (item.indexOf('@') != -1) {
                  if (item.split("@").length > 3) {
                    this.$Message.error('邮箱格式不正确！');
                    return;
                  }
                } else {
                  this.$Message.error('邮箱格式不正确！');
                  return;
                }
                var pushitem = item.split(",");
                var itememail = {
                  uuid: this.uuid(),
                  email: pushitem[0],
                  remarks: pushitem[1],
                }
                if (this.tabemailList.length>0) {
                  if (JSON.stringify(this.tabemailList).indexOf(pushitem[0])==-1) {
                    this.tabemailList.push(itememail);
                  }else{
                    this.$Message.error('邮箱地址不能重复！');
                    return;
                  }
                }else{
                  this.tabemailList.push(itememail);
                }
                
              }
            }
          } else {
            this.$Message.error('格式不正确！');
            return;
          }


        } catch (error) {
          this.$Message.error('格式不正确！');
          return;
        }
      },
      //添加邮箱
      addemailclick() {
        this.btnshowhide = true;
      },
      //获取稿件类目数据
      getManuscriptTypeOptions() {
        axios.get(this.baseUrl.hbjx + '/item/queryByparams', {  //params参数必写 , 如果没有参数传{}也可以
          params: {}
        })
          .then((res) => {
            this.manuscriptTypeOptions = res.data;
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      //上传数据
      saveData() {
        this.submitloading = true;
        let params = new FormData(); // 创建form对象
        params.append("title", this.ruleForm.title); // 标题
        params.append("author", this.ruleForm.author); //作者
        params.append("summary", this.ruleForm.abstract); //摘要
        params.append("userId", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //用户id
        params.append("editorsEmail", JSON.stringify(this.tabemailList)); //邮箱
        params.append("categoryId", JSON.stringify(this.ruleForm.manuscriptType)); //稿件类目
        params.append("categoryCustom", JSON.stringify(this.dynamicTags)); //自定义稿件类目
        params.append("isPublish", this.ruleForm.publicOrNot); //是否公开
        params.append("protocolContent", this.content); //协议内容
        axios.post(this.baseUrl.hbjx + "/contribution/saveTSelective", params).then((res) => {
          if (res.data.code == '200') {
            this.$router.push({
              path: '/createpagesuccess',
              query: {
                manuscriptId: res.data.contributionId,
                manuscriptTitle: this.ruleForm.title
              }
            })
            this.submitloading = false;
          } else {
            this.$Message.error('保存失败！');
            this.submitloading = false;
          }
        });
      },
      //保存按钮
      submitForm() {
        if (!this.ruleForm.title) {
          this.$Message.error('稿件标题不能为空！');
          return;
        }
        if (!this.ruleForm.author) {
          this.$Message.error('稿件作者不能为空！');
          return;
        }
        if (!this.ruleForm.manuscriptType) {
          this.$Message.error('稿件类目不能为空！');
          return;
        }
        if (this.tabemailList.length == 0) {
          this.$Message.error('请添加所投编辑邮箱列表！');
          return;
        }
        if (!this.content) {
          this.$Message.error('稿件协议不能为空！');
          return;
        }
        this.$confirm("是否确认此操作?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: 'true'
        })
          .then(() => {
            this.saveData();
          })
          .catch(() => { });
      },
      templateClick(index1) {
        var data = this.templateList;
        for (let index = 0; index < data.length; index++) {
          if (index == index1) {
            this.$set(this.templateList[index], 'state', true)
            this.content = this.templateList[index].content
          } else {
            this.$set(this.templateList[index], 'state', false)
          }
        }
      },
      //添加邮箱信息
      emailAdd() {
        if (this.tabemail != "" && this.tabremarks != "") {
          var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
          if (this.tabemail.indexOf('@') == -1) {
            this.$Message.error('邮箱格式不正确!');
            return;
          } else {
            var item = {
              uuid: this.uuid(),
              email: this.tabemail,
              remarks: this.tabremarks,
            }
            this.tabemailList.push(item);
            this.tabemail = "";
            this.tabremarks = "";
          }
        } else {
          if (this.tabemail == "") {
            this.$Message.error('邮箱不能为空!');
            return;
          } else {
            var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if (this.tabemail.indexOf('@') == -1) {
              this.$Message.error('邮箱格式不正确!');
              return;
            }
          }
          if (this.tabremarks == "") {
            this.$Message.error('备注不能为空!');
            return;
          }
        }

      },
      //失去焦点校验
      emailblur() {
        if (this.tabemail != '') {
          var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
          if (this.tabemail.indexOf('@') == -1) {
            this.$Message.error('邮箱格式不正确!');
          }
        }

      },
      deleterow(index) {
        this.tabemailList.splice(index, 1);
      },
      uuid() {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010  
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01  
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        return uuid;
      },
      //自定义节点
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        var ss = parseInt(this.ruleForm.manuscriptType.length);
        var dd = parseInt(this.dynamicTags.length);
        var num = parseInt(this.ruleForm.manuscriptType.length) + parseInt(this.dynamicTags.length);
        if (num >= 5) {
          this.$Message.error('最多只能选择5类标签！');
          return;
        }
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        if (this.inputValue.length > 5) {
          this.$Message.error('字符长度不能超过5位！');
          return;
        }
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      }
    }
  }
</script>

<style scoped>
  .topbarnodata {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    background-color: red;
    flex-direction: column;
    align-items: center;
  }

  /deep/ .el-cascader__tags .el-tag .el-icon-close {
    background-color: transparent;
    color: #409eff;
  }

  /deep/ .el-cascader__tags .el-tag .el-icon-close:hover {
    background-color: #5a9cf8;
    color: white;
  }

  /deep/ .el-cascader__tags .el-tag {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409EFF;
  }

  /deep/ .el-tag--small {
    height: 30px;
    padding: 0px 10px;
    line-height: 30px;
  }

  /deep/ .el-tag {
    height: 30px;
  }

  /deep/ .ql-container.ql-snow {
    border: none;
  }

  #templateid {
    width: 80px;
    height: 40px;
    border: 1px solid rgb(158, 156, 156);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
    cursor: pointer;
  }

  .active {
    background-color: #5297f7;
    color: white;
  }

  table {
    border-top: 1px solid rgb(158, 156, 156);
    border-left: 1px solid rgb(158, 156, 156);
    border-collapse: collapse;
    /*设置单元格的边框合并为1*/
  }

  td {
    border-bottom: 1px solid rgb(158, 156, 156);
    border-right: 1px solid rgb(158, 156, 156);
    text-align: center;
  }

  .myQuillEditor {
    height: 900px;
    border-bottom: 1px solid rgb(190, 190, 190);
  }

  .item {
    width: 200px;
    margin-top: 5px;
    margin-left: 5px;
    height: 30px;
    background-color: aqua;
    border-radius: 3px;
    text-align: center;
    line-height: 30px;
    color: black;
  }

  .editorEmail {
    width: 85%;
    margin-top: 35px;
    height: auto;
    display: flex;
    flex-direction: row;
  }

  .editorEmail1 {
    width: 85%;
    margin-top: 55px;
    height: auto;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .editorEmailleft {
    width: 110px;
    height: 100%;
    text-align: right;
    font-weight: bold;
    font-size: 18px;
    padding-right: 10px;
  }

  .editorEmailright {
    height: 100%;
    flex: 1;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  /deep/ .el-form-item__error {
    left: 15%;
  }

  /deep/ .el-input__inner {
    border: none;
    height: 35px;
    font-size: 16px;
    /* font-weight: bold; */
  }

  /deep/ .el-textarea__inner {
    border: none;
    font-size: 16px;
    /* font-weight: bold; */
  }

  #tablelist /deep/ .el-input__inner {
    border: none;
    height: 35px;
    font-size: 12px;
    text-align: center;

  }

  .titletext {
    width: 100%;
    height: 50px;
    font-weight: bold;
    text-align: center;
    font-size: 18px;
    line-height: 50px;
    margin: 30px 0px 30px 0px;
  }

  .titletext2 {
    width: 100%;
    height: 50px;
    font-weight: bold;
    text-align: center;
    font-size: 18px;
    line-height: 50px;
  }

  .row {
    width: 100%;
    height: 40px;
    display: flex;
    margin-top: 20px;
  }

  .rowleft {
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    font-size: 16px;
    font-weight: bold;
  }

  .rowright {
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgb(158, 156, 156);
  }


  .row1 {
    width: 100%;
    height: auto;
    display: flex;
    margin-top: 30px;
  }

  .rowleft1 {
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    font-size: 16px;
    font-weight: bold;
  }

  .rowright1 {
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowright2 {
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowright3 {
    height: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(158, 156, 156);
  }

  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    margin: 5px 0px 5px 0px;
    padding: 1em 0 2em;
    background-color: #fff;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    position: relative;
  }

  .page2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 8px 0px 10px 0px;
    padding: 1em 0 2em;
    background-color: #fff;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    position: relative;
  }


  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    /* line-height: 32px; */
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  /* .page:after {
    width: 180px;
    height: 30px;
    content: " ";
    margin-left: -90px;
    border: 1px solid rgba(200, 200, 200, .8);
    background: rgba(254, 254, 254, .6);
    -moz-box-shadow: 0px 0 3px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 0 3px rgb(0 0 0 / 10%);
    box-shadow: 0px 0 3px rgb(0 0 0 / 10%);
    -moz-transform: rotate(-5deg);
    -webkit-transform: rotate(-5deg);
    -o-transform: rotate(-5deg);
    transform: rotate(-5deg);
    position: absolute;
    left: 50%;
    top: -15px;
  } */
</style>


// WEBPACK FOOTER //
// src/components/CreatPage.vue